<div class="dialog">

    <div class="dialog-header">
        <h3>{{ 'PRICE_VERSION|Wersja cenowa' | translate }}</h3>
        <button
            iccIconButton
            (click)="close()"
            appearance="flat"
        >
            <icc-icon name="close"></icc-icon>
        </button>
    </div>
    <div class="dialog-body">

        <div class="flex-vertical w-100 flex-stretch">
            <icc-price-version-selector
                *ngIf='!data.document.isConfirmed && !data.document.isConfirmedOnlySalesPositions && data.document.salesDocumentTypeId !== 2'
                [class.invalid]="data.invalidVersion && !data.document.isCanceled && !data.priceUpdatePending"
                [activatedPriceVersion]="activatedPriceVersion"
                (priceVersionSelected)="changedPriceVersion($event)"
            >
            </icc-price-version-selector>
        </div>
    </div>
    <div class="dialog-footer">

        <div class="flex-horizontal w-100">
            <button
                iccButton
                (click)="close()"
                appearance="secondary"
            >
                {{ 'INTERFACE|Zamknij' | translate}}
            </button>
            <div class="right">
                <button
                    iccButton
                    (click)="change()"
                    appearance="primary"
                >
                    <icc-icon name="calculate"></icc-icon>
                    {{ 'PRICE_VERSION|Przelicz wersję cenową' | translate}}
                </button>

            </div>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>
